import { useUser } from 'builder/hooks/useUser'
import { useAutoApplyResumeDistributionModal } from './useAutoApplyResumeDistributionModal'
import { NonSupportedUserAutoApplyResumeDistributionModal } from './NonSupportedUserAutoApplyResumeDistributionModal'
import { SupportedUserAutoApplyResumeDistributionModal } from './SupportedUserAutoApplyResumeDistributionModal'

export const AutoApplyResumeDistributionModal = () => {
  const { isOpen, closeModal, planName, isInSupportedRegion, label } =
    useAutoApplyResumeDistributionModal()
  const user = useUser()

  if (!isOpen) return null

  if (isInSupportedRegion) {
    if (
      user?.scopes.resumeDistribution &&
      !['recurring', 'one_time'].includes(user.scopes.resumeDistributionCandidate || '')
    ) {
      return <SupportedUserAutoApplyResumeDistributionModal closeModal={closeModal} />
    }
    return null
  }

  return (
    <NonSupportedUserAutoApplyResumeDistributionModal
      planName={planName}
      closeModal={closeModal}
      label={label}
    />
  )
}
